import request from '../helpers/fetch';

const getBaseOffersApiUrl = () => WP_BASE_OFFERS_API_URL;

/**
 * This function submits a series of lender Ids to Offers API to get badge information
 * @param {Array} lenderIds The List of trusted lender-ID.
 * @param {Action} callBackFunction The callback action to be executed when API response is sucessfull.
 * @returns {Promise} Resolution/rejection of promise containing JSON object describing the outcome
 */
const getLenderBadges = (lenderIds, callBackFunction) => {
    const uniqueLenderIds = [...new Set(lenderIds)];
    const queryString = uniqueLenderIds.map(x => `lenderIds=${x}`).join('&');

    const endpoint = `${getBaseOffersApiUrl()}/api/lenders/lenderbadges?${queryString}`;

    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        mode: 'cors',
        credentials: 'include',
        cache: 'no-cache',
    };

    return request(endpoint, options)
        .then((response) => {
            const result = { success: false };
            const json = response;

            if (json !== undefined && json instanceof Object) {
                result.success = true;
                callBackFunction(json);
            } else {
                callBackFunction({});
                if (WP_LT_ENV !== 'prod') {
                    console.warn('Lender badge fetch not a success. Response undefined or not an object.');
                }
            }

            // Resolve even if there is a submission error (because endpoint responded, but something else is wrong),
            // so we can pass the message to app.vue
            return Promise.resolve(result);
        }).catch((error) => {
            const response = error && error.response && error.response.json !== undefined ? error.response.json : 'Network error';
            if (WP_LT_ENV !== 'prod') {
                console.error('Lender badge fetch not a success');
                console.error(response);
            }
            return Promise.reject(response);
        });
};

export default getLenderBadges;
